/**
 * Do not edit directly
 * Generated on Wed, 29 Dec 2021 17:59:47 GMT
 */

module.exports = {
  "borderRadius": {
    "1xsmall": "4px",
    "small": "8px",
    "medium": "12px",
    "large": "24px",
    "pill": "10rem",
    "circle": "50%"
  },
  "color": {
    "primary": {
      "softer": "#feede1",
      "soft": "#fba165",
      "base": "#c15106",
      "strong": "#903c04",
      "stronger": "#5e2803"
    },
    "accent": {
      "softer": "#d1d1e3",
      "soft": "#b6b9d0",
      "base": "#696d8c",
      "strong": "#50557c",
      "stronger": "#414563"
    },
    "informative": {
      "softer": "#e6eeff",
      "soft": "#7da2ff",
      "base": "#0c29d0",
      "strong": "#0a1f9c",
      "stronger": "#0b134a"
    },
    "alert": {
      "softer": "#ffeae5",
      "soft": "#fb775c",
      "base": "#d23718",
      "strong": "#ab351d",
      "stronger": "#6e0000"
    },
    "notice": {
      "softer": "#fff3d1",
      "soft": "#ffce4b",
      "base": "#dda100",
      "strong": "#956e07",
      "stronger": "#6e5001"
    },
    "success": {
      "softer": "#c9ffee",
      "soft": "#0dc78b",
      "base": "#00865b",
      "strong": "#086a4c",
      "stronger": "#054933"
    },
    "neutral": {
      "softest": "#ffffff",
      "softer": "#e5e5f2",
      "soft": "#d1d1e3",
      "base": "#696d8c",
      "strong": "#50557c",
      "stronger": "#312f4f"
    }
  },
  "fontFamily": {
    "brand": "soleil"
  },
  "fontSize": {
    "2xmini": "11px",
    "1xmini": "12px",
    "mini": "13px",
    "3xsmall": "14px",
    "2xsmall": "15px",
    "1xsmall": "16px",
    "small": "17px",
    "medium": "18px",
    "large": "20px",
    "1xlarge": "22px",
    "2xlarge": "24px",
    "3xlarge": "26px",
    "huge": "28px",
    "1xhuge": "32px",
    "2xhuge": "40px"
  },
  "fontWeight": {
    "regular": "400",
    "bold": "600"
  },
  "graphicAndData": {
    "color": {
      "brand1": {
        "softest": "#feede1",
        "softer": "#fba165",
        "soft": "#f36607",
        "base": "#c15106",
        "strong": "#903c04",
        "stronger": "#0b134a"
      },
      "brand2": {
        "softest": "#e6eeff",
        "softer": "#abc6ff",
        "soft": "#7da2ff",
        "base": "#364ef7",
        "strong": "#0c29d0",
        "stronger": "#0b134a"
      },
      "brand3": {
        "softest": "#f3deff",
        "softer": "#dea5fc",
        "soft": "#9905e8",
        "base": "#6a00a3",
        "strong": "#460469",
        "stronger": "#360252"
      },
      "brand4": {
        "softest": "#ffeae5",
        "softer": "#ff9a86",
        "soft": "#fb775c",
        "base": "#e64c2d",
        "strong": "#d23718",
        "stronger": "#ab351d"
      },
      "brand5": {
        "softest": "#fff3d1",
        "softer": "#ffe49b",
        "soft": "#f7bc1c",
        "base": "#edad00",
        "strong": "#dda100",
        "stronger": "#956e07"
      }
    }
  },
  "letterSpacing": {
    "tight": "0px",
    "loose": "2px"
  },
  "lineHeight": {
    "3xsmall": "12px",
    "2xsmall": "16px",
    "1xsmall": "20px",
    "small": "24px",
    "medium": "28px",
    "large": "32px",
    "1xlarge": "36px",
    "2xlarge": "40px",
    "3xlarge": "44px",
    "huge": "48px",
    "1xhuge": "52px",
    "2xhuge": "56px"
  },
  "opacity": {
    "base": "0.4",
    "strong": "0.8"
  },
  "shadow": {
    "low": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
    "high": "0px 4px 8px rgba(11, 19, 74, 0.1), 0px 8px 16px rgba(11, 19, 74, 0.08), 0px 16px 32px rgba(11, 19, 74, 0.06)",
    "higher": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
    "diffuse": "0px 0px 16px rgba(11, 19, 74, 0.1), 0px 0px 32px rgba(11, 19, 74, 0.08), 0px 0px 64px rgba(11, 19, 74, 0.06)"
  },
  "spacing": {
    "inline": {
      "none": "0px",
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px"
    },
    "inset": {
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px"
    },
    "squishedInset": {
      "1xsmall": "4px 8px",
      "small": "8px 16px",
      "medium": "12px 24px",
      "large": "16px 32px",
      "1xlarge": "24px 48px"
    },
    "stack": {
      "none": "0px",
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px",
      "3xlarge": "56px",
      "huge": "64px"
    },
    "stretchedInset": {
      "1xsmall": "8px 4px",
      "small": "16px 8px",
      "medium": "24px 12px",
      "large": "32px 16px",
      "1xlarge": "48px 24px"
    }
  },
  "components": {
    "text": {
      "title": {
        "large": {
          "desktop": {
            "fontSize": "40px",
            "lineHeight": "56px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "28px",
            "lineHeight": "36px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        }
      },
      "section": {
        "heading": {
          "large": {
            "desktop": {
              "fontSize": "32px",
              "lineHeight": "44px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "24px",
              "lineHeight": "32px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            }
          },
          "default": {
            "desktop": {
              "fontSize": "24px",
              "lineHeight": "32px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "18px",
              "lineHeight": "24px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            }
          }
        },
        "subheading": {
          "large": {
            "desktop": {
              "fontSize": "26px",
              "lineHeight": "36px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "22px",
              "lineHeight": "28px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            }
          },
          "default": {
            "desktop": {
              "fontSize": "22px",
              "lineHeight": "28px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "16px",
              "lineHeight": "20px",
              "fontWeight": "600",
              "letterSpacing": "0px"
            }
          }
        }
      },
      "detailedSubheading": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "24px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        }
      },
      "paragraph": {
        "lg": {
          "large": {
            "desktop": {
              "fontSize": "24px",
              "lineHeight": "36px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "20px",
              "lineHeight": "28px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            }
          },
          "default": {
            "desktop": {
              "fontSize": "18px",
              "lineHeight": "28px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "17px",
              "lineHeight": "24px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            }
          }
        },
        "md": {
          "large": {
            "desktop": {
              "fontSize": "18px",
              "lineHeight": "28px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "18px",
              "lineHeight": "28px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            }
          },
          "default": {
            "desktop": {
              "fontSize": "16px",
              "lineHeight": "24px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "15px",
              "lineHeight": "20px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            }
          }
        }
      },
      "caption": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "13px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        }
      },
      "overline": {
        "lg": {
          "large": {
            "desktop": {
              "fontSize": "22px",
              "lineHeight": "32px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "22px",
              "lineHeight": "32px",
              "fontWeight": "400",
              "letterSpacing": "2px"
            }
          },
          "default": {
            "desktop": {
              "fontSize": "16px",
              "lineHeight": "24px",
              "fontWeight": "400",
              "letterSpacing": "2px"
            },
            "mobile": {
              "fontSize": "16px",
              "lineHeight": "24px",
              "fontWeight": "400",
              "letterSpacing": "2px"
            }
          }
        },
        "md": {
          "large": {
            "desktop": {
              "fontSize": "16px",
              "lineHeight": "24px",
              "fontWeight": "400",
              "letterSpacing": "0px"
            },
            "mobile": {
              "fontSize": "18px",
              "lineHeight": "28px",
              "fontWeight": "400",
              "letterSpacing": "2px"
            }
          },
          "default": {
            "desktop": {
              "fontSize": "14px",
              "lineHeight": "20px",
              "fontWeight": "400",
              "letterSpacing": "2px"
            },
            "mobile": {
              "fontSize": "14px",
              "lineHeight": "20px",
              "fontWeight": "400",
              "letterSpacing": "2px"
            }
          }
        }
      }
    }
  }
};